var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderOrganization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.63,
    cy: 50.92,
    fill: "#BDC1C6",
    r: 9.57
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.06 27.85c2.36-4.73.44-10.47-4.28-12.84-4.73-2.36-10.48-.45-12.84 4.28L44.73 43.72l10.65 21.41c.02 0 .03 0 .05-.01l18.63-37.28zm37.72 88.1c4.7-2.4 6.57-8.15 4.17-12.87l-5.44-10.71a8.47 8.47 0 0 0-.44-.97c-.3-.59-.61-1.15-.93-1.72l-.02-.05c-.18-.35-.38-.68-.59-1-7.12-11.88-18.85-20.55-32.83-23.42l23.1 46.35.1.2a9.565 9.565 0 0 0 8.25 5.23c.14.01.29.01.43.01a9.67 9.67 0 0 0 4.14-1.01c.02-.01.05-.02.07-.03zM64.49 83.4l-9.11-18.26c3.21-.65 6.54-.99 9.96-.99 3.55 0 7.01.37 10.36 1.07l16.82 33.76c-5.43-9.68-15.61-15.59-27.19-15.59-.28 0-.56 0-.84.01z",
    fill: "#BDC1C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.73 43.72 21.31 90.57c-.52.96-1.01 1.94-1.47 2.93-.02.05-.04.09-.06.13l-4.75 9.51a9.573 9.573 0 0 0 4.28 12.84c4.73 2.36 10.48.45 12.84-4.28l6.91-13.83c1.8-2.83 4.04-5.35 6.61-7.45L36.98 73c5.46-3.8 11.7-6.53 18.48-7.89-.8-1.6-1.01-2.03-1.32-2.61-.64-1.26-1.65-3.23-9.39-18.79z",
    fill: "#BDC1C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m45.66 90.43-8.69-17.42c5.46-3.8 11.7-6.53 18.48-7.89l9.11 18.27c-7.13.18-13.69 2.77-18.9 7.03z",
    fill: "#BDC1C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderOrganization);
export default __webpack_public_path__ + "static/media/placeholder_organization.9a7087f4b1ce133ae61c66f668197f72.svg";
export { ForwardRef as ReactComponent };